// src/components/SectionWrapper/SectionWrapper.jsx
import React from "react";

export default function SectionWrapper({ id, bg = "bg-joyrideLight dark:bg-joyrideNavy", children }) {
  return (
    <section id={id} className={`${bg} w-full transition-colors duration-300 py-12`}>
      <div className="max-w-6xl mx-auto px-4 md:px-8 lg:px-16">
        {children}
      </div>
    </section>
  );
}
